var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "BjSelectSqlLov" },
    [
      _c(
        "el-input",
        {
          style: "width:" + _vm.width,
          attrs: {
            readonly: _vm.readonly,
            disabled: _vm.disabled,
            placeholder: _vm.placeholder || _vm.$t("chooseText"),
            size: _vm.size,
            clearable: _vm.clearable,
          },
          model: {
            value: _vm.valueName,
            callback: function ($$v) {
              _vm.valueName = $$v
            },
            expression: "valueName",
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "append" }, slot: "append" },
            [
              _vm.valueName && _vm.clearable
                ? _c("el-button", {
                    attrs: {
                      disabled: _vm.disabled,
                      icon: "el-icon-circle-close",
                    },
                    on: { click: _vm.clear },
                  })
                : _vm._e(),
              _c("el-button", {
                attrs: { disabled: _vm.disabled, icon: "el-icon-search" },
                on: { click: _vm.showDialog },
              }),
            ],
            1
          ),
        ]
      ),
      _vm.lovView.viewCode
        ? _c("BjDialogList", {
            ref: "dialogList",
            attrs: {
              "is-list": _vm.cptIsList,
              config: _vm.dialogListConfig,
              disabled: _vm.disabledIds,
              multiple: _vm.multiple,
              "row-key": _vm.cptRowKey,
              "tag-name": _vm.cptTagName,
            },
            on: { confirm: _vm.onConfirmDialogList },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }